"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _link = require("../link");

var _utils = require("../utils");

var _constants = require("./constants");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var MessageBannerLink = _link.Link.withComponent('a', {
  target: "e1mfx37y0"
});

MessageBannerLink.defaultProps = _objectSpread(_objectSpread({}, _link.Link.defaultProps), {}, {
  color: _constants.TEXT_COLOR,
  fontSize: _constants.FONT_SIZE,
  fontWeight: 'medium'
});
var MessageBannerLinkWithDocs = (0, _stencilReactDesc.describe)(MessageBannerLink).description('Link component styled to fit in a message banner.');
MessageBannerLinkWithDocs.propTypes = _objectSpread({}, _link.Link.describedPropTypes); // withComponent has to be redefined because of Link's wrapper-like internal structure

MessageBannerLinkWithDocs.withComponent = function (tag) {
  var LinkWithComponent = _link.Link.withComponent(tag, {
    target: "e1mfx37y1"
  });

  LinkWithComponent.defaultProps = _objectSpread({}, MessageBannerLink.defaultProps);
  return /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
    return (0, _core.jsx)(LinkWithComponent, (0, _extends2.default)({}, props, {
      ref: ref
    }));
  });
};

var MessageBannerLinkWithTestAttributes = (0, _utils.withTestAttributes)({
  component: 'MessageBannerLink'
})(MessageBannerLink);
MessageBannerLinkWithTestAttributes.displayName = 'MessageBannerLink';
var _default = MessageBannerLinkWithTestAttributes;
exports.default = _default;